import React from "react";
import Card from "../../Card/Card";
import CardBody from "../../Card/CardBody";
import CardHeader from "../../Card/CardHeader";
import CardIcon from "../../Card/CardIcon";
import { makeStyles } from "@mui/styles";
import styles from "../../../assets/jss/material-dashboard-pro-react/views/chartsStyle";
import PropTypes from "prop-types";
import InfoArea from "../../InfoArea/InfoArea";
import InfoIcon from '@mui/icons-material/Info';
import { CustomNoDataTitleStyle, LoadingDiv, cardHeaderStyle } from "../../../assets/jss/material-dashboard-pro-react/components/Analyses/CustomSelectHeader";

const noDataClassStyle = makeStyles((theme) => ({
    root: {
        fontFamily: '"Source Sans Pro",sans-serif',
        fontSize: '24px',
        color: '#585858',
        position: 'relative',
        top: '2em'
    },
}))

const useStyles = makeStyles(styles);

function CustomNoData(props) {
    const classes = useStyles();
    const noDataStyle = noDataClassStyle();
    const description = (<span style={{ fontSize: "13px" }}>Aucune donnée à afficher</span>);


    return (
        <div>
             <Card raised={true} chart style={{marginTop: '15px',marginBottom: '40px'}}> 
            {/* <Card raised={true} chart> */}
                <CardHeader color="info" icon style={cardHeaderStyle}>
                    <CardIcon color="info">
                        <InfoIcon />
                    </CardIcon>
                    <h4 style={styles.cardIconTitle}>
                        {props.chartTitle}
                    </h4>
                    <div style={{ height: "5px", width: "5px" }}></div>
                </CardHeader>
                <CardBody>
                    <div>
                        <LoadingDiv>
                            {description}
                        </LoadingDiv>
                    </div>

                </CardBody>
            </Card>
        </div>
    )

}

CustomNoData.propTypes = {
    chartTitle: PropTypes.string,
}

export default CustomNoData;